import { Button, ButtonProps, forwardRef } from '@chakra-ui/react';
import React from 'react';

type GradientButtonProps = ButtonProps & {};

const GradientButton = forwardRef<GradientButtonProps, 'button'>(({ children, ...props }, ref) => {
    return (
        <Button
            ref={ref}
            color="background"
            variant="solid"
            transition={'0.5s'}
            backgroundImage={'linear-gradient(to left, #DABEE2, #42abab)'}
            backgroundSize="200% auto"
            _hover={{ backgroundPosition: 'right bottom' }}
            _active={{ backgroundPosition: 'right bottom' }}
            {...props}
        >
            {children}
        </Button>
    );
});

export default GradientButton;
